import { Injectable } from '@angular/core';
import { Events, LoadingController, Platform } from 'ionic-angular';
import { Globals } from '../../globals';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs';

interface Notification {
  UID: string;
  UID_RESTAURANT: string;
  UID_USER: string;
  title: string;
  description: string;
  date: any;
}

@Injectable()


export class NotificationsServices {

  //fs
  notificationCol: AngularFirestoreCollection<Notification>;
  notifications_observable: Observable<Notification[]>;
  notificationDoc: AngularFirestoreDocument<Notification>;

  //vars
  notifications_badge: number = 0;
  valueChanges: any;
  notifications = [];
  notifications_open: boolean = false;
  show: boolean = true;
  notificationsCount2Delete: number = 0;
  notificationsCountDelenting: number = 0;

  constructor(public events: Events,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    public translate: TranslateService,
    public globals: Globals,
    public afs: AngularFirestore) {
  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/

  //notification push
  notificationPushOneUser(notification) {
    if (this.globals.checkLimitsByLicense('notification', 'notification')) {
      this.afs.collection('notifications').add({
        'UID_RESTAURANT': notification.UID_RESTAURANT,
        'UID_USER': notification.UID_USER,
        'title': notification.title,
        'description': notification.description,
        'date': new Date()
      });
    }
  }

  //notificacion por rol
  notificationPushByRol(notification, rol) {
    if (this.globals.users_array) {
      //for por el usuario que tenga el rol
      for (let user of this.globals.users_array) {
        if (user.rol == rol) {
          notification.UID_USER = user.uid_auth;
          this.notificationPushOneUser(notification);
        }
      }
    }
  }

  //notificacion que envia a todos los usuarios del restaurante
  notificationPushAllRestaurant(notification) {
    if (this.globals.users_array) {
      for (let user of this.globals.users_array) {
        notification.UID_USER = user.uid_auth;
        this.notificationPushOneUser(notification);
      }
    }
  }

  //get notifications and badge count
  getNotificationsBadge(uid_auth) {
    this.notificationCol = this.afs.collection('notifications', ref =>
      ref.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .where('UID_USER', '==', uid_auth)
        .orderBy('date', 'desc'));
    this.notifications_observable = this.notificationCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Notification;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
    //
    this.notificationCol.snapshotChanges().subscribe(value => {
      this.notifications = [];
      var count = 0;
      value.map((a, index) => {
        const data = a.payload.doc.data() as Notification;
        data.UID = a.payload.doc.id;
        this.notifications.push(data);
        count++;
        return data;
      });
      this.notifications_badge = count;
    });
    
    //nos suscribimos cuando el estado del documento es added
    this.notificationCol.stateChanges(['added']).subscribe(value => {
      value.map((a, index) => {
        const data = a.payload.doc.data() as Notification;
        data.UID = a.payload.doc.id;
        return data;
      });
      this.globals.toast_notifications = true;
    });
  }

  //open or close notifications
  openCloseNotificationsModal() {
    if (this.notifications_open) {
      this.notifications_open = false;
    } else {
      this.notifications_open = true;
    }
  }

  //clean all notifications
  async cleanAllNotifications() {
    var fist_time = true;
    //solo borrar en caso hay notificaciones
    if (this.notifications.length > 0) {
      this.notificationsCount2Delete = this.notifications.length;
      this.notificationsCountDelenting = 0;
      this.show = false;
      //
      for (let notification of this.notifications) {
        this.notificationsCountDelenting++;
        this.afs.doc('notifications/' + notification.UID).delete().then(() => {
          //en este caso siempre acaba de borrar
          if (fist_time) {
            this.show = true;
            fist_time = false;
          }
        });
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/services/notificationsServices.ts